export default {
  updateCategoryIndex(state, data) {
    state.categoryIndex = data;
  },
};
